export function resolveNotificationStoreId(
  source?: {
    storeId?: unknown;
    store_id?: unknown;
    data?: { storeId?: unknown; store_id?: unknown } | null;
  } | null
): number | null {
  const raw =
    source?.storeId ??
    source?.store_id ??
    source?.data?.storeId ??
    source?.data?.store_id;
  const storeId = Number(raw);
  return Number.isFinite(storeId) && storeId > 0 ? storeId : null;
}

export function isNotificationForStore(
  source: {
    storeId?: unknown;
    store_id?: unknown;
    type?: unknown;
    data?: { storeId?: unknown; store_id?: unknown; type?: unknown } | null;
  } | null | undefined,
  currentStoreId: number | null | undefined
): boolean {
  if (currentStoreId == null) return false;
  const storeId = resolveNotificationStoreId(source);
  if (storeId == null) return false;
  return storeId === Number(currentStoreId);
}

export function isCentreConversationNotice(
  source?: { type?: unknown; data?: { type?: unknown } | null } | null
): boolean {
  const type = source?.type ?? source?.data?.type;
  return type === 'CENTRE_MESSAGE';
}
